import React from 'react'
import { Tabs, Card } from 'antd'

import ProfileForm from './components/ProfileForm'
import PasswordForm from './components/PasswordForm'

export const Account = props => (
  <Tabs defaultActiveKey="profile" tabPosition="left">
    <Tabs.TabPane tab="Profile" key="profile">
      <Card title="Profile" style={{ maxWidth: 320 }}>
        <ProfileForm {...props} />
      </Card>
    </Tabs.TabPane>
    <Tabs.TabPane tab="Change password" key="password">
      <Card title="Change password" style={{ maxWidth: 320 }}>
        <PasswordForm {...props} />
      </Card>
    </Tabs.TabPane>
  </Tabs>
)

export default Account



// WEBPACK FOOTER //
// ./src/pages/Account/index.js